/**
 * Price formatting utilities
 */

/**
 * Apply tax to price based on country
 * @param {number} num - Price amount
 * @param {string} country - Country code
 * @param {number} tax - Tax multiplier
 * @returns {number} Price with tax applied
 */
export function applyTax(num, country, tax) {
  if (['au', 'AU', 'nz', 'NZ'].indexOf(country) > -1) {
    return num;
  }
  return num * tax;
}

/**
 * Format price with currency symbol
 * @param {number} num - Price amount
 * @param {string} culture - Culture code (e.g., 'en-au')
 * @param {string} currency - Currency code (e.g., 'AUD')
 * @param {string} country - Country code
 * @param {number} tax - Tax multiplier
 * @returns {string} Formatted price string
 */
export function formatPrice(num, culture, currency, country = null, tax = 1) {
  const amount = country && tax ? applyTax(num, country, tax) : num;
  return new Intl.NumberFormat(culture, { 
    style: 'currency', 
    currency: currency 
  }).format(amount);
}

/**
 * Get price suffix for GST display
 * @param {string} culture - Culture code
 * @returns {string} Price suffix (e.g., "(Inc GST)" or "")
 */
export function getPriceSuffix(culture) {
  if (['en-au', 'en-nz'].includes(culture)) {
    return '(Inc GST)';
  }
  return '';
}

